// extracted by mini-css-extract-plugin
module.exports = {"container":"Alert_container__1YfAW"};